import React from "react";

const Availability = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M3.975 18c0-7.733 6.292-14.025 14.025-14.025 7.733 0 14.025 6.292 14.025 14.025 0 7.733-6.292 14.025-14.025 14.025V34c8.822 0 16-7.178 16-16S26.822 2 18 2 2 9.178 2 18h1.975z"
            fill={fill}
        />
        <path
            className="u_fill"
            d="M27.68 12.89L18.57 22l-1.191 1.192L16.188 22l-4.538-4.538 2.086-2.086 3.79 3.79 8.56-8.558C23.669 8.24 20.974 7.053 18 7.053c-6.046 0-10.947 4.9-10.947 10.947 0 6.046 4.901 10.947 10.947 10.947 6.046 0 10.947-4.901 10.947-10.947 0-1.846-.459-3.585-1.266-5.11z"
            fill={fill}
        />
    </svg>
);

export default Availability;